import { createSlice } from '@reduxjs/toolkit';
import { fetchCampaigns } from '../actions/campaign.action';

const initialState = {
  campaigns: {
    data: [],
    total: 0,
    isLoading: false,
    isNeedReloadData: true,
  },
};

export const campaignReducer = createSlice({
  name: 'Campaign',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchCampaigns.pending, state => {
        state.campaigns.isLoading = true;
        state.campaigns.isNeedReloadData = false;
      })
      .addCase(fetchCampaigns.rejected, state => {
        state.campaigns.isLoading = false;
      })
      .addCase(fetchCampaigns.fulfilled, (state, action) => {
        if (action.payload) {
          const { data, total } = action.payload;

          state.campaigns = {
            ...state.campaigns,
            data,
            total,
            isLoading: false,
          };
        }
      });
  },
});

export default campaignReducer.reducer;
